import { create } from 'zustand';

/**
 * 결재함 사이드바 알림 표시를 위한 전역 카운트 상태
 *
 * - 미결함 > 결재중 문서가 존재하는지 여부를 사이드바에서 표시하기 위해 사용
 * - Sidebar와 ApproverPage 간 상태 공유 목적
 * - null: 로딩 중
 * - 0   : 결재중 문서 없음
 * - 1↑  : 결재중 문서 있음
 */
const useApprovalCountStore = create((set) => ({
  approvalIngCount: null, // null = 로딩 중
  setApprovalIngCount: (count) => set({ approvalIngCount: count }),
}));

export default useApprovalCountStore;
